import * as yup from 'yup';

import { EmailCreateFormValues } from '~/core/shared/types';

export const emailCreateValidationSchema: yup.ObjectSchema<EmailCreateFormValues> =
  yup.object({
    bcc: yup
      .string()
      .test('emails', 'Invalid email addresses', (value) =>
        value
          ? value
              .split(',')
              .every((email) => yup.string().trim().email().isValidSync(email))
          : true,
      ),
    content: yup.string().trim().required(),
    subject: yup.string().trim().required(),
  });
